let isUploadedby = "";
let outerurl = "";
let file_type = "";
let vidUrl = "";
let stop_or_canceled = "";

let camera_stream = null;
let media_recorder = null;
let blobs_recorded = [];
let intervalID = null;

let element = document.getElementById("main_content_uploader");
let main_bg = document.getElementById("main-bg");
let web_cam_msg = document.getElementById("web_cam_msg");
let camera_button = document.querySelector("#start-camera");
let unmute = document.querySelector("#unmute");
let video = document.querySelector("#video");
let start_button = document.querySelector("#start-record");
let stop_button = document.querySelector("#stop-record");
let download_link = document.querySelector("#download-video");
let click_button = document.querySelector("#click-photo");
let cancel = document.querySelector("#cancel");
let upload = document.querySelector("#upload");
let canvas = document.querySelector("#canvas");
let showvideo = document.querySelector("#showvideo");
let timer = document.querySelector("#timer");
let retake = document.querySelector("#retake");
let mutebutton = document.getElementById("unmute");
let vidLink = document.querySelector("#vid-link");
let imgLink = document.querySelector("#img-link");
let Reset = document.querySelector("#Reset");
let Rslider = document.querySelector("#Rslider");
let Rslider2 = document.querySelector("#Rslider2");
let mobile_picture_input = document.querySelector("#mobile_picture_input");
let mobile_video_input = document.querySelector("#mobile_video_input");
let mobileshowvideo = document.querySelector("#mobileshowvideo");
let pictureFromCamera = document.querySelector("#pictureFromCamera");

let tab_2_open_camera = document.querySelector("#tab_2_open_camera");
let tab_3_open_camera = document.querySelector("#tab_3_open_camera");
let myHiddenInputField = document.querySelector("#myHiddenInputField");
let local_file_upload_button = document.querySelector(
  "#local_file_upload_button"
);
let local_file_add_more_button = document.querySelector(
  "#local_file_add_more_button"
);
let progressBar = document.querySelector("#progressBar");
local_file_upload_button.style.display = "none";
local_file_add_more_button.style.display = "none";

function SetHiddenInputFieldValue(url) {
  myHiddenInputField.value = url;
  console.log(myHiddenInputField.value);
}

tab_2_open_camera.style.display = "none";
tab_3_open_camera.style.display = "none";

function showHideProgressBar() {
  progressBar.style.display = "block";
}

function validateFileUpload(event) {
  const fileInput = event.target;
  const file = fileInput.files[0];
  const fileType = file.type;

  if (!(fileType.startsWith("image/") || fileType.startsWith("video/"))) {
    alert("Please upload only image or video files.");
    fileInput.value = ""; // reset the file input
  }
}

// script to open mobile camera start
// ----------------------Start-----------------------------

// for image
showvideo.style.display = "none";
mobileshowvideo.style.display = "none";
mobile_picture_input.addEventListener("change", function () {
  file_type = "image";
  let image_url = window.URL.createObjectURL(this.files[0]);
  outerurl = image_url;
  console.log(this.files[0].type);
  showvideo.style.display = "none";
  mobileshowvideo.style.display = "none";
  pictureFromCamera.style.display = "block";
  pictureFromCamera.setAttribute("src", outerurl);
});

//   for video
mobile_video_input.addEventListener("change", function () {
  file_type = "video";
  console.log(this.files[0].type);
  let selectedFile = this.files[0];
  let videoUrl = URL.createObjectURL(selectedFile);
  vidUrl = videoUrl;
  mobileshowvideo.src = videoUrl;
  mobileshowvideo.style.display = "block";
  pictureFromCamera.src = "";
  pictureFromCamera.style.display = "none";
});
// ----------------------end-----------------------------
function ResetZoomandRotate() {
  Rslider.value = "1";
  Rslider2.value = "0";
  jQuery("#vid-link").attr("style", "");
  jQuery("#img-link").attr("style", "");
}

Reset.addEventListener("click", function () {
  ResetZoomandRotate();
});

function checkVideoOrientation(video) {
  element.classList.add("by-video");
  if (video.videoWidth > video.videoHeight) {
    element.classList.remove("Portrait");
    element.classList.add("Landscape");
    main_bg.src =
      "https://cdn.shopify.com/s/files/1/0692/6539/1916/files/frame1.png?v=1762933481";
    document.getElementById("landscape-checked").checked = true;
    document.getElementById("portrait-checked").checked = false;
  } else {
    element.classList.remove("Landscape");
    element.classList.add("Portrait");
    main_bg.src =
      "https://cdn.shopify.com/s/files/1/0692/6539/1916/files/frame_4095bc6b-4208-4a61-8130-95243bb0e5f5.png?v=1762932791";
    document.getElementById("portrait-checked").checked = true;

    document.getElementById("landscape-checked").checked = false;
  }
}

function checkImageOrientation(image) {
  element.classList.remove("by-video");
  var w = image.naturalWidth || image.width,
    h = image.naturalHeight || image.height;

  if (isUploadedby == "device") {
    document.getElementById("img-link").classList.add("uploaded");
  } else if (isUploadedby == "canvas") {
    document.getElementById("uploaded-video").classList.add("canvas-img");
  }
  isUploadedby = "";

  if (h < w) {
    element.classList.remove("Portrait");
    element.classList.add("Landscape");
    main_bg.src =
      "https://cdn.shopify.com/s/files/1/0692/6539/1916/files/frame1.png?v=1762933481";
  } else {
    element.classList.remove("Landscape");
    element.classList.add("Portrait");
    main_bg.src =
      "https://cdn.shopify.com/s/files/1/0692/6539/1916/files/frame_4095bc6b-4208-4a61-8130-95243bb0e5f5.png?v=1762932791";
  }
}

vidLink.addEventListener("loadedmetadata", function () {
  ResetZoomandRotate();
  checkVideoOrientation(vidLink);
});
imgLink.addEventListener("load", function () {
  ResetZoomandRotate();
  checkImageOrientation(imgLink);
});

function ReturnTime(sec) {
  const totalSeconds = sec;
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;
  if (hours != 00) {
    return `${hours}:${minutes}:${seconds}`;
  } else {
    return `${minutes}:${seconds}`;
  }
}

function startTimer() {
  var start = Date.now();
  intervalID = setInterval(function () {
    var delta = Date.now() - start; // milliseconds elapsed since start
    timer.innerHTML = ReturnTime(Math.floor(delta / 1000));
  }, 1000); // update about every second
}

async function InitializeCamera() {
  clearInterval(intervalID);

  file_type = "";

  canvas.style.display = "none";

  vidLink.src = "";
  vidLink.load();

  showvideo.src = "";
  showvideo.load();
  stop_or_canceled = "";

  if (media_recorder != null) {
    media_recorder.stop();
  }

  showvideo.style.display = "none";

  cancel.style.display = "none";
  upload.style.display = "none";
  stop_button.style.display = "none";
  download_link.style.display = "none";
  timer.style.display = "none";
  retake.style.display = "none";
  timer.innerHTML = "";

  video.style.display = "block";
  unmute.style.display = "none";
  click_button.style.display = "none";
  start_button.style.display = "none";
  mutebutton.innerHTML = "unmute";
  try {
    camera_stream = await navigator.mediaDevices.getUserMedia({
      video: true,
      audio: false,
    });
    blobs_recorded = [];
    video.srcObject = camera_stream;

    unmute.style.display = "block";
    start_button.style.display = "block";

    click_button.style.display = "block";
  } catch (err) {
    web_cam_msg.innerHTML = "Web cam not found";
  }
}
unmute.addEventListener("click", async function () {
  blobs_recorded = [];
  if (mutebutton.innerHTML == "mute") {
    mutebutton.innerHTML = "unmute";
    InitializeCamera();
  } else {
    mutebutton.innerHTML = "mute";
    camera_stream = await navigator.mediaDevices.getUserMedia({
      video: true,
      audio: true,
    });
    video.srcObject = camera_stream;
  }
});
click_button.addEventListener("click", function () {
  canvas.setAttribute("width", 320);
  canvas.setAttribute("height", video.videoHeight / (video.videoWidth / 320));
  isUploadedby = "canvas";
  file_type = "image";
  canvas.getContext("2d").drawImage(video, 0, 0, canvas.width, canvas.height);
  let image_data_url = canvas.toDataURL("image/jpeg");

  file_type = "image";
  outerurl = image_data_url;

  showvideo.style.display = "none";
  video.style.display = "none";
  unmute.style.display = "none";
  download_link.style.display = "none";
  click_button.style.display = "none";
  start_button.style.display = "none";
  stop_button.style.display = "none";
  canvas.style.display = "block";
  cancel.style.display = "block";
  upload.style.display = "block";
});

start_button.addEventListener("click", function async() {
  clearInterval(intervalID);
  start_button.style.display = "none";
  click_button.style.display = "none";
  unmute.style.display = "none";
  cancel.style.display = "block";
  stop_button.style.display = "block";
  timer.style.display = "block";
  startTimer();
  blobs_recorded = [];
  if (MediaRecorder.isTypeSupported("video/webm; codecs=vp9")) {
    var options = { mimeType: "video/webm; codecs=vp9" };
  } else if (MediaRecorder.isTypeSupported("video/webm")) {
    var options = { mimeType: "video/webm" };
  } else if (MediaRecorder.isTypeSupported("video/mp4")) {
    var options = { mimeType: "video/mp4", videoBitsPerSecond: 100000 };
  } else {
    web_cam_msg.innerHTML = "no suitable mimetype found for this device";
  }

  media_recorder = new MediaRecorder(camera_stream, options);

  // event : new recorded video blob available
  media_recorder.addEventListener("dataavailable", function (e) {
    blobs_recorded.push(e.data);
  });

  // event : recording stopped & all blobs sent
  media_recorder.addEventListener("stop", function () {
    file_type = "video";

    if (stop_or_canceled == "stop") {
      console.log("blobs_recordedblobs_recorded", blobs_recorded);

      let video_local = URL.createObjectURL(
        new Blob(blobs_recorded, { type: "video/MP4" })
      );
      upload.style.display = "block";
      download_link.href = video_local;
      console.log("video_localvideo_localvideo_local", video_local);
      vidUrl = video_local;

      showvideo.style.display = "block";

      vidLink.src = "";
      vidLink.load();

      showvideo.src = "";
      showvideo.load();

      showvideo.src = video_local;
      showvideo.load();

      showvideo.style.display = "none";
      showvideo.onloadeddata = function () {
        showvideo.play();
        showvideo.style.display = "block";
      };
      stop_or_canceled = "";
    } else {
      blobs_recorded = [];
    }
    media_recorder = null;
  });

  media_recorder.start(1000);
});

stop_button.addEventListener("click", function () {
  retake.style.display = "block";
  video.style.display = "none";
  timer.style.display = "none";
  stop_button.style.display = "none";
  vidLink.src = "";
  vidLink.load();
  showvideo.src = "";
  showvideo.load();
  timer.innerHTML = "";
  clearInterval(intervalID);
  stop_or_canceled = "stop";
  media_recorder.stop();
});

jQuery("button").click(function () {
  jQuery(".popup").fadeIn(500);
});
jQuery(".close").click(function () {
  jQuery(".popup").fadeOut(500);
});
jQuery(function () {
  const tabLinks = jQuery("#tab-links li a");

  tabLinks.click(function (event) {
    var $this = jQuery(this);

    event.preventDefault();

    jQuery("#tab-links a.active, section.active").removeClass("active");

    $this.addClass("active");
    jQuery($this.attr("href")).addClass("active");
  });
});

function readFile(input) {
  $(".ag-drop-completed").remove();
  if (input.files && input.files[0]) {
    var reader = new FileReader();

    reader.onprogress = (event) => {
      if (event.lengthComputable) {
        const progress = (event.loaded / event.total) * 100;
        progressBar.value = progress;

        if (progress == 100) {
          progressBar.style.display = "none";
          $("#progressBar").after(
            '<span style=" background: #042C62; color: #fff; font-size: 9px; width: 100%; display: block; text-align: center; margin-top: 10px; border-radius: 20px; " class="ag-drop-completed">Preview Ready</span>'
          );
        }
      }
    };

    reader.onload = function (e) {
      console.log();
      var htmlPreview;
      if (input.files[0].type.split("/")[0] === "image") {
        htmlPreview =
          '<img width="200" src="' +
          e.target.result +
          '" />' +
          "<p>" +
          input.files[0].name +
          "</p>";
      } else {
        const videoElement = document.createElement("video");
        videoElement.src = reader.result;
        videoElement.width = 50;
        videoElement.height = 50;

        htmlPreview =
          videoElement.outerHTML + "<p>" + input.files[0].name + "</p>";
      }

      var wrapperZone = $(input).parent();
      var previewZone = $(input).parent().parent().find(".preview-zone");
      var boxZone = $(input)
        .parent()
        .parent()
        .find(".preview-zone")
        .find(".box")
        .find(".box-body");

      wrapperZone.removeClass("dragover");
      previewZone.removeClass("hidden");
      previewZone.addClass("abc");
      boxZone.empty();
      boxZone.append(htmlPreview);
      local_file_upload_button.style.display = "block";
    };
    reader.readAsDataURL(input.files[0]);
  }
}

function reset(e) {
  e.wrap("<form>").closest("form").get(0).reset();
  //     var previewZone = $(input).parent().parent().find('.preview-zone');
  //   previewZone.removeClass('abc');

  e.unwrap();
}

$("#local_file_add_more_button").on("click", function () {
  $("#upload-form").click();
});

window.onload = function () {
  Dropzone.options.uploadForm = {
    // The camelized version of the ID of the form element

    // The configuration we've talked about above
    autoProcessQueue: false,
    uploadMultiple: true,
    parallelUploads: 100,
    maxFiles: 100,
    maxFilesize: 5000,
    addRemoveLinks: true,
    acceptedFiles: "image/*,video/*",
    // The setting up of the dropzone
    init: function () {
      var myDropzone = this;
      this.on("addedfile", (file) => {
        local_file_upload_button.style.display = "block";
        local_file_add_more_button.style.display = "block";
      });
      this.on("removedfile", (file) => {
        if (myDropzone.getAcceptedFiles().length == 0) {
          local_file_upload_button.style.display = "none";
          local_file_add_more_button.style.display = "none";
        }
      });
      // First change the button to actually tell Dropzone to process the queue.
      document
        .querySelector("#local_file_upload_button")
        .addEventListener("click", function (e) {
          $(".progress-bars-all").html("");
          $(".ag_hidden_field_upload").html("");
          // Make sure that the form isn't actually being sent.
          // e.preventDefault();
          // e.stopPropagation();
          // myDropzone.processQueue();
          var dropzone_files = myDropzone.getAcceptedFiles();
          console.log(myDropzone.getAcceptedFiles());

          isUploadedby = "device";
          let type = dropzone_files[dropzone_files.length - 1].type.split("/");
          //progressBar.style.display = "block";

          var tmppath = URL.createObjectURL(
            dropzone_files[dropzone_files.length - 1]
          );
          outerurl = tmppath;
          vidUrl = tmppath;

          if (type[0] == "image") {
            file_type = "image";
          } else if (type[0] == "video") {
            file_type = "video";
          } else {
          }
          $(".all-files-names-p").remove();
          $(".progress-bars-all").before(
            '<div class="all-files-names-p"></div>'
          );
          $.each(dropzone_files, function (index, value) {
            $(".all-files-names-p").append("<h5>" + value.name + "</h5>");
          });
          var total_progresses = [];
          setURL(dropzone_files, 0, total_progresses);
        });

      // Listen to the sendingmultiple event. In this case, it's the sendingmultiple event instead
      // of the sending event because uploadMultiple is set to true.
      this.on("sendingmultiple", function () {
        // Gets triggered when the form is actually being sent.
        // Hide the success button or the complete form.
      });
      this.on("successmultiple", function (files, response) {
        // Gets triggered when the files have successfully been sent.
        // Redirect user or notify of success.
      });
      this.on("errormultiple", function (files, response) {
        // Gets triggered when there was an error sending the files.
        // Maybe show form again, and notify user of error
      });
    },
  };
};

function setURL(file__, file_number_, total_progresses) {
  if (file_number_ == 0) {
    $(".progress-bars-all").append(
      '<div class="progress-g' +
        file_number_ +
        ' progress-g" style="display:none;"><div class="progress-bar"></div></div>'
    );
  }
  // code by AG start

  //var f__ = jQuery('input.dropzone[type="file"]').prop('files');
  var form = new FormData();

  form.append("sendimage", file__[file_number_]);

  // var settings = {
  //   xhr: function() {
  //             var xhr = new window.XMLHttpRequest();
  //             xhr.upload.addEventListener("progress", function(evt) {
  //                 if (evt.lengthComputable) {
  //                     var percentComplete = ((evt.loaded / evt.total) * 100);
  //                     $(".progress-bar").width(percentComplete.toFixed(0) + '%');
  //                     $(".progress-bar").html(percentComplete.toFixed(0)+'%');
  //                 }
  //             }, false);
  //             return xhr;
  //         },
  //   "cache": false,
  //   // "dataType": "json",
  //   "async": true,
  //   "crossDomain": true,
  //   "url": "https://atul.cloud1.me/nurcare-upload/api-file-upload.php",
  //   "method": "POST",
  //   "timeout": 0,
  //   "processData": false,
  //   beforeSend: function(){
  //           jQuery(".progress-g").show();
  //             jQuery(".progress-bar").width('0%');

  //         },
  //   "mimeType": "multipart/form-data",
  //   "contentType": false,
  //   "data": form
  // };

  var file = file__[file_number_];
  var access_token__ = "";
  var settings___ = {
    url: "https://api.dropboxapi.com/oauth2/token",
    method: "POST",
    timeout: 0,
    headers: {
      Authorization: "Basic OHJza21hNnhrMnJpb3A4OmtoYWpia2d1OXdxbTk5Zw==",
      "Content-Type": "application/x-www-form-urlencoded",
    },
    data: {
      grant_type: "refresh_token",
      refresh_token:
        "oJbrUeM59EAAAAAAAAAAAaz8ZeajXhTifrnKakvRyl05VfFxWYnylMqgsHbd2MbI",
    },
  };

  jQuery.ajax(settings___).done(function (response) {
    access_token__ = response.access_token;
    console.log(access_token__);

    var settings = {
      xhr: function () {
        var xhr = new window.XMLHttpRequest();
        xhr.upload.addEventListener(
          "progress",
          function (evt) {
            if (evt.lengthComputable) {
              var percentComplete = (evt.loaded / evt.total) * 100;
              total_progresses[file_number_] = percentComplete / file__.length;
              var t_p = 0;
              console.log(total_progresses);
              $.each(total_progresses, function (index, value) {
                t_p = t_p + total_progresses[index];
              });

              console.log(t_p);
              $(".progress-g0 .progress-bar").width(t_p.toFixed(0) + "%");
              $(".progress-g0 .progress-bar").html(t_p.toFixed(0) + "%");
            }
          },
          false
        );
        return xhr;
      },
      cache: false,
      // "dataType": "json",
      async: true,
      crossDomain: true,
      url: "https://content.dropboxapi.com/2/files/upload",
      method: "POST",
      timeout: 0,
      processData: false,
      beforeSend: function () {
        jQuery(".progress-g" + file_number_ + ".progress-g").show();
        jQuery(".edit-row").show();
        jQuery(".rotate-sliders").show();
        jQuery(".progress-g" + file_number_ + " .progress-bar").width("0%");
      },
      mimeType: "multipart/form-data",
      contentType: false,
      headers: {
        "Dropbox-API-Arg":
          '{"path": "/Dropbox/Apps/mobytag/' +
          file.name +
          '","mode": "add","autorename": true, "mute": false, "strict_conflict": false}',
        "Content-Type": "application/octet-stream",
        Authorization: "Bearer " + access_token__,
      },
      data: file,
    };
    // var settings = {
    //   "url": "https://content.dropboxapi.com/2/files/upload",
    //   "method": "POST",
    //   "timeout": 0,
    //   "headers": {
    //     "Dropbox-API-Arg": "{\"path\": \"/Dropbox/Apps/mobytag/"+file.name+"\",\"mode\": \"add\",\"autorename\": true, \"mute\": false, \"strict_conflict\": false}",
    //     "Content-Type": "application/octet-stream",
    //     "Authorization": "Bearer sl.BaGlnXz0s8eu1N-YwC7ESErRzprd2awQ2WtKZ_Mp9sHiWFKD459O6H6dh3q-kOj4wO4y_PnWBFJKBZGG5-kBr2kuM7i32NgSQZIz_mAww_EGjGkdHEsnM_fQLUV7s4btdFMfEBR7"
    //   },
    //    "data": file,
    //     "processData": false,
    //       "contentType": false,
    // };

    jQuery.ajax(settings).done(function (response) {
      var res_data = JSON.parse(response);
      console.log(res_data);

      var settings__ = {
        cache: false,
        // "dataType": "json",
        async: true,
        crossDomain: true,
        url: "https://api.dropboxapi.com/2/sharing/get_file_metadata",
        method: "POST",
        timeout: 0,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + access_token__,
        },
        data: JSON.stringify({
          file: res_data.id,
          actions: [],
        }),
      };

      jQuery.ajax(settings__).done(function (response) {
        console.log(response);
        var form_d__ = jQuery(".ag_hidden_field_upload").attr("data-f-form");
        jQuery(".ag_hidden_field_upload").append(
          '<input form="' +
            form_d__ +
            '" type="hidden" value="' +
            response.preview_url +
            '&preview_=/uploads/" name="properties[Upload ' +
            (file_number_ + 1) +
            ']" class="ag-new-uploaded-file">'
        );

        // var pre_val = jQuery('#ag-new-uploaded-file').val();
        // if(pre_val != ''){
        //   pre_val = pre_val+','+response.preview_url;
        // }
        // else{
        //   pre_val = response.preview_url;
        // }
        // jQuery('#ag-new-uploaded-file').val(pre_val);
        if (file_number_ < file__.length - 1) {
          setURL(file__, file_number_ + 1, total_progresses);
        } else {
          $(".progress-g0 .progress-bar").html("Completed");
        }
      });
      // jQuery('#ag-new-uploaded-file').val(res_data.url);
    });
  });

  // code by AG end

  modal.style.display = "none";
  if (file_type == "image") {
    imgLink.src = outerurl;
    SetHiddenInputFieldValue(outerurl);
    vidLink.src = "";
    vidLink.load();
  } else if (file_type == "video") {
    vidLink.src = vidUrl;
    vidLink.load();
    SetHiddenInputFieldValue(vidUrl);
    imgLink.src = "";
  }
}

jQuery(".m-button").click(function () {
  jQuery(".m-button").toggleClass("mute");
});

jQuery(document).ready(function () {
  jQuery("#Rslider").on("input", function () {
    jQuery("#vid-link,#img-link").css(
      "transform",
      "scale(" + this.value + ") rotate(" + jQuery("#Rslider2").val() + "deg)"
    );
    jQuery("#vid-link,#img-link").css("z-index", "9");
    jQuery("#vid-link,#img-link").css("transition", "all 0.5s ease 0s");
    if (this.value == "1.1") {
      //   jQuery(".uploadkit.uploadkit-injected img, .custom-frame").css("z-index", "999");
    }
  });

  jQuery("#Rslider2").on("input", function () {
    jQuery("#vid-link,#img-link").css(
      "transform",
      "scale(" + jQuery("#Rslider").val() + ") rotate(" + this.value + "deg)"
    );
    jQuery("#vid-link,#img-link").css("transform", "9");
    jQuery("#vid-link,#img-link").css("transition", "all 0.5s ease 0s");
    if (this.value == "1.1") {
      //   jQuery(".uploadkit.uploadkit-injected img, .custom-frame").css("z-index", "999");
    }
  });
});

jQuery(document).ready(function () {
  jQuery("#Rslider").on("input", function () {
    jQuery("video#vid-link").css(
      "transform",
      "scale(" + this.value + ") rotate(" + jQuery("#Rslider2").val() + "deg)"
    );
    jQuery("video#vid-link").css("z-index", "9");
    jQuery("video#vid-link").css("transition", "all 0.5s ease 0s");
    if (this.value == "1.1") {
      jQuery("img#img-link, div#uploaded-video video").css("z-index", "999");
    }
  });

  jQuery("#Rslider2").on("input", function () {
    jQuery("video#vid-link").css(
      "transform",
      "scale(" + jQuery("#Rslider").val() + ") rotate(" + this.value + "deg)"
    );
    jQuery("video#vid-link").css("transform", "9");
    jQuery("video#vid-link").css("transition", "all 0.5s ease 0s");
    if (this.value == "1.1") {
      jQuery("img#img-link, div#uploaded-video video").css("z-index", "999");
    }
  });
});

// function changeImage(radio) {
//   if (radio.value == "portrait-img") {
//     document.getElementById("img#main-bg").src = "image1.jpg";
//   } else if (radio.value == "landscape-img") {
//     document.getElementById("img#main-bg").src = "image2.jpg";
//   }
// }

function changeImage(radio) {
  if (radio.value == "portrait-img") {
    document.getElementById("main-bg").src =
      "https://cdn.shopify.com/s/files/1/0692/6539/1916/files/frame_4095bc6b-4208-4a61-8130-95243bb0e5f5.png?v=1762932791";
    $("#main_content_uploader").addClass("Portrait1");
    $("#main_content_uploader").removeClass("Landscape");
  } else if (radio.value == "landscape-img") {
    $("#main_content_uploader").addClass("Landscape");
    $("#main_content_uploader").removeClass("Portrait");

    document.getElementById("main-bg").src =
      "https://cdn.shopify.com/s/files/1/0692/6539/1916/files/frame1.png?v=1762933481";
  }
}

// Get the modal
var modal = document.getElementById("myModal");

// Get the button that opens the modal
var btn = document.getElementById("myBtn");

// Get the <span> element that closes the modal
var span = document.getElementsByClassName("close2")[0];

// When the user clicks the button, open the modal
btn.onclick = function () {
  modal.style.display = "block";
};

// When the user clicks on <span> (x), close the modal
span.onclick = function () {
  modal.style.display = "none";
};

// When the user clicks anywhere outside of the modal, close it
window.onclick = function (event) {
  if (event.target == modal) {
    modal.style.display = "none";
  }
};

// popup initiate

// const showDialog = document.getElementById("show-dialog");
// const dialog = document.getElementById("dialog");
// const hideDialog = document.getElementById("close-dialog");

// showDialog.addEventListener("click", () => {
//   dialog.showModal();
// });

// hideDialog.addEventListener("click", () => {
//   dialog.close();
// });

// dialog.addEventListener("click", (e) => {
//   if (e.target.tagName === "DIALOG") {
//     dialog.close();
//   }
// });

//step form

/**
 * Define a function to navigate betweens form steps.
 * It accepts one parameter. That is - step number.
 */
const navigateToFormStep = (stepNumber) => {
  /**
   * Hide all form steps.
   */
  document.querySelectorAll(".form-step").forEach((formStepElement) => {
    formStepElement.classList.add("d-none");
  });
  /**
   * Mark all form steps as unfinished.
   */
  document.querySelectorAll(".form-stepper-list").forEach((formStepHeader) => {
    formStepHeader.classList.add("form-stepper-unfinished");
    formStepHeader.classList.remove(
      "form-stepper-active",
      "form-stepper-completed"
    );
  });
  /**
   * Show the current form step (as passed to the function).
   */
  document.querySelector("#step-" + stepNumber).classList.remove("d-none");
  /**
   * Select the form step circle (progress bar).
   */
  const formStepCircle = document.querySelector(
    'li[step="' + stepNumber + '"]'
  );
  /**
   * Mark the current form step as active.
   */
  formStepCircle.classList.remove(
    "form-stepper-unfinished",
    "form-stepper-completed"
  );
  formStepCircle.classList.add("form-stepper-active");
  /**
   * Loop through each form step circles.
   * This loop will continue up to the current step number.
   * Example: If the current step is 3,
   * then the loop will perform operations for step 1 and 2.
   */
  for (let index = 0; index < stepNumber; index++) {
    /**
     * Select the form step circle (progress bar).
     */
    const formStepCircle = document.querySelector('li[step="' + index + '"]');
    /**
     * Check if the element exist. If yes, then proceed.
     */
    if (formStepCircle) {
      /**
       * Mark the form step as completed.
       */
      formStepCircle.classList.remove(
        "form-stepper-unfinished",
        "form-stepper-active"
      );
      formStepCircle.classList.add("form-stepper-completed");
    }
  }
};
/**
 * Select all form navigation buttons, and loop through them.
 */
document
  .querySelectorAll(".btn-navigate-form-step")
  .forEach((formNavigationBtn) => {
    /**
     * Add a click event listener to the button.
     */
    formNavigationBtn.addEventListener("click", () => {
      /**
       * Get the value of the step.
       */
      const stepNumber = parseInt(
        formNavigationBtn.getAttribute("step_number")
      );
      /**
       * Call the function to navigate to the target form step.
       */
      navigateToFormStep(stepNumber);
    });
  });

// show hide step form

$(document).ready(function () {
  $("#start-upload").click(function () {
    $(".step-form").addClass("show");
    $(".flex").addClass("hide");
  });
});

